module.exports = __webpack_public_path__ + "static/media/jovi-logo.d5b5c022.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jovi-logo.svg
// module id = 63
// module chunks = 0